import {
	Directive,
	ElementRef,
	HostListener,
	Input,
	OnDestroy,
} from '@angular/core';

@Directive({
	selector: '[appTooltip]',
	exportAs: 'appTooltip',
})
export class TooltipDirective implements OnDestroy {
	@Input() appTooltip = ''; // The text for the tooltip to display
	@Input() delay? = 0; // Optional delay input, in ms
	@Input() tooltipOnlyWhenOverflowing = false; // Only show when the host's content is truncated

	private myPopup;
	private timer;

	constructor(private el: ElementRef) {}

	ngOnDestroy(): void {
		if (this.myPopup) {
			this.myPopup.remove();
		}
	}

	@HostListener('mouseenter') onMouseEnter() {
		if (!this.appTooltip) {
			return;
		}

		if (this.tooltipOnlyWhenOverflowing && !this.isOverflowing()) {
			return;
		}

		this.timer = setTimeout(() => this.createTooltipPopup(this.el.nativeElement.getBoundingClientRect()), this.delay);
	}

	@HostListener('mouseleave') onMouseLeave() {
		this.hide();
	}

	public hide(): void {
		document.querySelectorAll('.a-tooltip').forEach((element) => element.remove());

		if (this.timer) {
			clearTimeout(this.timer);
		}
	}

	private isOverflowing(): boolean {
		const el = this.el.nativeElement;
		return el.scrollWidth > el.clientWidth;
	}

	// Below the host, centred on it; above it when the window has no room below, and
	// shifted sideways so it never runs past the window edge.
	private createTooltipPopup(host: DOMRect) {
		const gap = 6;
		const margin = 8;
		const x = host.left + host.width / 2;
		const popup = document.createElement('div');
		popup.innerHTML = this.appTooltip;
		popup.setAttribute('class', 'a-tooltip');
		popup.style.top = (host.bottom + gap) + 'px';
		popup.style.left = x + 'px';
		document.body.appendChild(popup);

		const rect = popup.getBoundingClientRect();
		if (rect.bottom > window.innerHeight - margin) {
			popup.style.top = Math.max(margin, host.top - gap - rect.height) + 'px';
		}
		if (rect.right > window.innerWidth - margin) {
			popup.style.left = (x - (rect.right - (window.innerWidth - margin))) + 'px';
		} else if (rect.left < margin) {
			popup.style.left = (margin + rect.width / 2) + 'px';
		}

		this.myPopup = popup;
	}
}
